module.exports = __webpack_public_path__ + "img/info-kiosk.34dfbbe0.webp";